import axios from 'axios'

export const downloadTdmSoftware = (parameters: string) => {
  const formData = new FormData()
  formData.append('data', parameters)
  axios
    .post('https://tdmsolutions.com/updates', formData)
    .then((response) => {
      const url = response.data.data.url
      const link = document.createElement('a')
      link.href = url
      document.body.appendChild(link)
      link.click()
    })
    .catch((error) => {
      console.log(error)
    })
}

export const downloadInstaller = (appId: string) => {
  const rhinoVersion = null
  let url = `https://p2ngvcs2q5.execute-api.us-east-1.amazonaws.com/software-version?appId=${appId}`
  if (rhinoVersion) url += `&rhinoVersion=${rhinoVersion}` // This condition is not working for now
  axios
    .get(url)
    .then((response) => {
      const url = response.data.result.data.url
      const link = document.createElement('a')
      link.href = url
      document.body.appendChild(link)
      link.click()
    })
    .catch((error) => {
      console.log(error)
    })
}
